module.exports = new __parcel__URL__("BricksInMotion.7da6989b.jpeg").toString();